import React from 'react';
import { graphql } from 'gatsby';
import { SimpleHero as SimpleHeroComponent } from '../../../simpleHero/SimpleHero';

export const SimpleHero = ({ data, ...rest }) => {
  const getColor = (color) => {
    switch (color) {
      case 'Grey':
        return 'neutralLightGrey';
      case 'White':
        return 'neutralWhite';
      default:
        return 'neutralWhite';
    }
  };
  return (
    <SimpleHeroComponent
      {...data}
      backgroundColor={getColor(data.background)}
      {...rest}
    />
  );
};

export const SimpleHeroQuery = graphql`
  fragment SimpleHero on UMBRACO_SimpleHeroComponentType {
    heading
    description
    background
  }
`;
